
import { Link } from 'react-router-dom';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

export default function ServiceDetail() {
  const challenges = [
    {
      icon: 'ri-time-line',
      title: '配送時間の短縮',
      description: '従来の配送ルートでは時間がかかりすぎる'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'コスト削減',
      description: '物流費用を抑えながら品質を維持したい'
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全性の確保',
      description: '大切な商品を確実に届けたい'
    },
    {
      icon: 'ri-customer-service-line',
      title: '柔軟な対応',
      description: '急な配送依頼にも対応してほしい'
    }
  ];

  const solutions = [
    {
      icon: 'ri-route-line',
      title: '最適ルート設計',
      description: 'GPS技術と豊富な経験を活かし、最短・最適なルートを設計します。'
    },
    {
      icon: 'ri-team-line',
      title: '専任チーム制',
      description: 'お客様専任のチームを編成し、継続的なサービス向上を図ります。'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'リアルタイム追跡',
      description: '配送状況をリアルタイムで確認できるシステムを提供します。'
    },
    {
      icon: 'ri-24-hours-line',
      title: '24時間対応',
      description: '緊急時や急な配送依頼にも柔軟に対応いたします。'
    }
  ];

  const process = [
    {
      step: '01',
      title: 'ヒアリング',
      description: 'お客様のニーズと課題を詳しくお聞きします',
      icon: 'ri-question-answer-line'
    },
    {
      step: '02',
      title: '現状分析',
      description: '現在の物流状況を分析し、改善点を特定します',
      icon: 'ri-search-line'
    },
    {
      step: '03',
      title: '提案書作成',
      description: '最適な物流ソリューションをご提案します',
      icon: 'ri-file-text-line'
    },
    {
      step: '04',
      title: '実施・運用',
      description: '提案内容に基づき、実際の配送サービスを開始します',
      icon: 'ri-truck-line'
    },
    {
      step: '05',
      title: '継続改善',
      description: '定期的な見直しでサービス品質を向上させます',
      icon: 'ri-refresh-line'
    }
  ];

  const results = [
    {
      metric: '配送時間',
      before: '平均3時間',
      after: '平均1.5時間',
      improvement: '50%短縮'
    },
    {
      metric: '物流コスト',
      before: '月額50万円',
      after: '月額35万円',
      improvement: '30%削減'
    },
    {
      metric: '配送精度',
      before: '95%',
      after: '99.8%',
      improvement: '4.8%向上'
    },
    {
      metric: '顧客満足度',
      before: '80%',
      after: '96%',
      improvement: '16%向上'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* ヒーローセクション */}
      <section 
        className="relative h-96 flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(30, 58, 138, 0.8), rgba(30, 58, 138, 0.8)), url('https://public.readdy.ai/ai/img_res/453bd16de47ee6cd652a57e91f1849e2.jpg')`
        }}
      >
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">サービス詳細</h1>
          <p className="text-xl text-blue-200">Service Detail</p>
        </div>
      </section>

      {/* 課題 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              お客様の課題
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto">
              物流に関する様々な課題をお持ちではありませんか？SUNFIELDがお客様の課題を解決いたします。
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {challenges.map((challenge, index) => (
              <div key={index} className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
                <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${challenge.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-lg font-bold text-red-700 mb-3">{challenge.title}</h3>
                <p className="text-red-600 text-sm leading-relaxed">{challenge.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 解決策 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              SUNFIELDの解決策
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto">
              豊富な経験と最新技術を組み合わせ、お客様の課題に対する最適なソリューションを提供します。
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {solutions.map((solution, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-6 text-center hover:shadow-xl transition-shadow duration-300">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-900 to-blue-800 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${solution.icon} text-2xl text-yellow-400`}></i>
                </div>
                <h3 className="text-lg font-bold text-blue-900 mb-3">{solution.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{solution.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 実施プロセス */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              実施プロセス
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto">
              お客様との密な連携により、段階的にサービスを導入・改善していきます。
            </p>
          </div>

          <div className="relative">
            {/* プロセスライン */}
            <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-blue-200 transform -translate-y-1/2"></div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
              {process.map((step, index) => (
                <div key={index} className="relative">
                  <div className="bg-white border-4 border-blue-900 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4 relative z-10">
                    <span className="text-blue-900 font-bold text-lg">{step.step}</span>
                  </div>
                  <div className="text-center">
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i className={`${step.icon} text-blue-900 text-xl`}></i>
                    </div>
                    <h3 className="text-lg font-bold text-blue-900 mb-2">{step.title}</h3>
                    <p className="text-gray-600 text-sm leading-relaxed">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 成果・実績 */}
      <section className="py-20 bg-blue-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              導入成果
            </h2>
            <p className="text-xl text-blue-200 max-w-4xl mx-auto">
              実際にサービスを導入いただいたお客様の成果をご紹介します。
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {results.map((result, index) => (
              <div key={index} className="bg-white rounded-xl p-6 text-center">
                <h3 className="text-lg font-bold text-blue-900 mb-4">{result.metric}</h3>
                <div className="space-y-2 mb-4">
                  <div className="text-sm text-gray-600">
                    導入前: <span className="font-semibold">{result.before}</span>
                  </div>
                  <div className="text-sm text-gray-600">
                    導入後: <span className="font-semibold text-blue-900">{result.after}</span>
                  </div>
                </div>
                <div className="bg-yellow-400 text-blue-900 font-bold py-2 px-4 rounded-full text-sm">
                  {result.improvement}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-blue-200 mb-6">
              ※成果は導入企業様の実績例です。効果には個別差があります。
            </p>
          </div>
        </div>
      </section>

      {/* 事例紹介 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              導入事例
            </h2>
            <p className="text-xl text-gray-600">
              製造業A社様の事例
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8 lg:p-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h3 className="text-2xl font-bold text-blue-900 mb-6">課題と解決策</h3>
                <div className="space-y-6">
                  <div className="border-l-4 border-red-500 pl-4">
                    <h4 className="font-bold text-red-700 mb-2">課題</h4>
                    <p className="text-gray-700">
                      従来の配送業者では、急な配送依頼に対応できず、顧客からのクレームが増加していた。また、配送コストも年々上昇し、利益を圧迫していた。
                    </p>
                  </div>
                  <div className="border-l-4 border-blue-500 pl-4">
                    <h4 className="font-bold text-blue-700 mb-2">解決策</h4>
                    <p className="text-gray-700">
                      SUNFIELDの24時間対応体制と専任チーム制により、急な配送依頼にも柔軟に対応。最適ルート設計により配送効率を向上させ、コスト削減を実現。
                    </p>
                  </div>
                  <div className="border-l-4 border-green-500 pl-4">
                    <h4 className="font-bold text-green-700 mb-2">成果</h4>
                    <p className="text-gray-700">
                      配送時間50%短縮、コスト30%削減を達成。顧客満足度も大幅に向上し、新規取引先の獲得にもつながった。
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <img
                  src="https://readdy.ai/api/search-image?query=Manufacturing%20company%20warehouse%20with%20efficient%20logistics%20operations%2C%20modern%20industrial%20facility%20with%20organized%20inventory%20and%20transportation%2C%20professional%20business%20photography&width=600&height=400&seq=case-study&orientation=landscape"
                  alt="導入事例"
                  className="rounded-xl shadow-lg w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6">
            あなたの物流課題も解決できます
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            まずは無料相談で、お客様の課題をお聞かせください。最適なソリューションをご提案いたします。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-yellow-400 text-blue-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-yellow-300 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              無料相談予約
            </Link>
            <Link
              to="/works"
              className="border-2 border-blue-900 text-blue-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-blue-900 hover:text-white transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-eye-line mr-2"></i>
              他の事例を見る
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
